import clsx from "clsx";

export default function SectionTitle({
  title,
  className,
}: {
  title: string;
  className?: string;
}) {
  return (
    <h2
      className={clsx(
        "md:text-6xl",
        "text-black",
        "font-medium",
        "text-center",
        "max-w-sm",
        "mx-auto",
        "leading-8",
        "md:leading-14",
        "md:max-w-4xl",
        "px-7",
        "lg:px-0",
        "pt-12",
        "md:pt-20",
        "pb-12",
        "text-[32px]",
        "tracking-tighter",
        className
      )}
    >
      {title}
    </h2>
  );
}
